export const getYYYYMMDD = (d) => {
  return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000).toISOString().split('T')[0]
}

export const fromUtcToDate = (utc, separator = '/') => {
  const date = new Date(utc)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  const yyyy = date.getFullYear()
  return `${dd}${separator}${mm}${separator}${yyyy}`
}
